import React from 'react';
import {QuickSettingsForm, FormFieldConfig} from '@/components/forms';
import {useStoreActions} from 'easy-peasy';
import {useAlert} from '@/components/alerts';
import * as yup from 'yup';
import i18n from 'i18n';

interface FormValues {
    description: string;
    valid: boolean;
}

interface ApiTokenSettingsFormProps {
    tokenId?: number;
    onSave?: () => void;
}

const ApiTokenSettingsForm: React.FC<ApiTokenSettingsFormProps> = React.memo((
    {
        tokenId = 0,
        onSave = () => {},
    },
) => {
    const {showSuccess} = useAlert();
    const setActiveToken = useStoreActions((actions: any) => actions.apiTokens.setActiveItem);
    const setReloadApiTokens = useStoreActions((actions: any) => actions.apiTokens.setReload);

    const initialValues: FormValues = {
        description: '',
        valid: true,
    };

    const customSuccessHandling = (response: any, actionName: string) => {
        if (!tokenId) {
            setActiveToken(response.data.item.accessToken);
        }

        if (tokenId) {
            showSuccess(i18n.t('to_token_ch.text'));
        } else {
            showSuccess(i18n.t('to_token_cr.text'));
        }
        
        setReloadApiTokens(true);
        onSave?.();
    };

    const fields: FormFieldConfig[] = [
        {
            name: 'description',
            label: i18n.t('jt_token_description.text'),
            type: 'text',
            required: true,
            validation: yup.string()
                .max(255, 'Maximum allowed description length is 255 characters')
                .required('Required field'),
        },
        {
            name: 'valid',
            label: i18n.t('es_valid.text'),
            type: 'switch',
            required: false,
            validation: yup.boolean(),
        },
    ];

    return (
        <QuickSettingsForm
            entityId={tokenId || undefined}
            crudConfig={{
                resourceUrl: window.URLS.tokensResource,
                storeActionPath: 'apiTokens.addOrEdit',
                successMessageKey: 'jt_save.text',
                entityName: 'token'
            }}
            fields={fields}
            initialValues={initialValues}
            onSave={onSave}
            customSuccessHandling={customSuccessHandling}
            additionalStoreActions={[
                {
                    path: 'apiTokens.setReload',
                    value: true,
                },
            ]}
        />
    );
});


export default ApiTokenSettingsForm; 